var angular = require("angular");
var _ = require("underscore");

 angular
  .module("app.directives")
  .directive("contentUpload", ['$docUpload', function($docUpload) {
    return {
      restrict: "E",
      scope: {
        imageUpload: "=data",
        title: "=label",
        publicUpload: "=",
        initialFilename: "=",
        alwaysShowFileName: "@",
        allowDelete: "@",
        validationFilter: "@filter",
      },
      template: require("./template.pug"),
      controller: function($scope, $timeout) {
        $scope.allowedFiles = $docUpload.GetAllowedUploadTypes($scope.validationFilter);

        if ($scope.allowDelete === '') { // if attribute not specified, default to true
          $scope.allowDeleteBool = true;
        } else {
          // attribute values bound with "@" come in as strings - convert string to bool
          $scope.allowDeleteBool = ($scope.allowDelete === "true");
        }

        if ($scope.alwaysShowFileName === '') { // if attribute not specified, default to true
          $scope.alwaysShowFileNameBool = true;
        } else {
          // attribute values bound with "@" come in as strings - convert string to bool
          $scope.alwaysShowFileNameBool = ($scope.alwaysShowFileName === "true");
        }

        if (!$scope.imageUpload) {
          throw "Must give content-upload directive a data attribute bound to an object to handle upload info";
        }

        ($scope.imageUpload.reset = function() {
          $scope.imageUpload.ready = false;
          $scope.imageUpload.done = false;
          $scope.imageUpload.busy = false;
          $scope.imageUpload.files = [];
          $scope.imageUpload.failedFiles = [];
          $scope.imageUpload.request = null;
          $scope.imageUpload.id = null;
          $scope.imageUpload.url = null;
          $scope.imageUpload.thumb_url = null;
        })();

        $scope.deleteFile = function() {
          $scope.file = null;
          $scope.imageUpload.reset();
          $scope.imageUpload.onDone(null);
        }

        $scope.uploadImage = function() {
          $timeout($scope.uploadImageInternal());
        };
        $scope.uploadImageInternal = function() {
          var onErrorCallback = function(failedFile) {
            $scope.imageUpload.busy = false;
            $scope.imageUpload.failedFiles.push(failedFile);
          };
          
          var onPendingCallback = function(file) {
            $scope.file = file;
          };
          
          var onSuccessCallback = function() {
            $scope.imageUpload.onDone($scope.file.id, $scope.file.name, $scope.file.size);
            $scope.imageUpload.failedFiles = [];
            $scope.imageUpload.busy = false;
          }

          // files property may be single file or array with single file;
          // first, check property for null
          var fileOrFiles = $scope.imageUpload.files;
          if (!fileOrFiles) return;

          // deal with array/object difference
          var file;
          if (Array.isArray(fileOrFiles)) {
            // check array has an element - bail if not
            if (fileOrFiles.length === 0) return;
            file = fileOrFiles[0];
          } else {
            // just grab the file object
            file = fileOrFiles;
          }

          $scope.imageUpload.busy = true;
          $docUpload.HandleUploadAction([file],
                                        $scope.validationFilter,
                                        onErrorCallback,
                                        onPendingCallback,
                                        onSuccessCallback);
        };
      },
      link: function(scope, elem, attrs) {
      }
    };
  }]);
